import { canUseDOM } from 'exenv';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import throttle from 'lodash/throttle';
import Post from '../../../components/post/post';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import { loadAllThirdPartyJs } from '../../../../client/utils/third_party_js_util';
import adsConfig from '../../../../server/config/ads';
import { buildPostAdModel } from '../../../../utils/ad_util';
import matchMediaDesktop from '../../../../utils/client_util';
import { infiniteScrollUrlChange } from '../../../../redux/action_creators/postpage_action_creators';
import asyncPostFiniteActions from '../../../../redux/actions/async_post_finite_actions';

let scriptjs = false;

if (canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = require('scriptjs');
}

class PostPage extends Component {
  constructor() {
    super();

    this.setScrollEvents = this.setScrollEvents.bind(this);
    this.generateAdData = this.generateAdData.bind(this);
  }

  componentDidMount() {
    const { statusCode, config, post } = this.props;

    this.window = window;
    this.body = document.body;
    this.activePost = get(post, 'id') || get(this.props, 'match.params.id');
    this.lazyThresholdFromBottom = 400;
    this.stickySidebar = matchMediaDesktop();
    this.trackedPosts = [];

    this.setActiveSocial();
    window.addEventListener('scroll', throttle(this.setScrollEvents, 100));

    if (statusCode !== 404 && statusCode !== 403 && statusCode !== 500) {
      const postId = get(this.props, 'match.params.id');
      this.props.dispatchPostFinite(postId, config);
    }
  }

  componentDidUpdate() {
    this.loading = false;

    const relatedPosts = document.querySelectorAll('.related-posts');
    const totalPosts = relatedPosts.length;
    this.relatedHeight = totalPosts
      ? relatedPosts[totalPosts - 1].offsetHeight
      : 0;

    if (canUseDOM && totalPosts > 1) {
      if (!window.instgrm) {
        scriptjs('//platform.instagram.com/en_US/embeds.js', () => {
          window.instgrm.Embeds.process();
        });
      } else {
        window.instgrm.Embeds.process();
      }

      if (!window.twttr) {
        scriptjs('//platform.twitter.com/widgets.js', () => {
          window.twttr.widgets.load();
        });
      } else {
        window.twttr.widgets.load();
      }
    }

    this.posts = this.getPostElements();
  }

  componentWillUnmount() {
    this.window.removeEventListener('scroll', this.setScrollEvents);
  }

  getPostElements() {
    return document.querySelectorAll('.post__wrapper');
  }

  setActiveSocial(post) {
    const activeClass = 'social--active';
    const activeSocial = document.querySelector(`.${activeClass}`);

    if (activeSocial) {
      activeSocial.classList.remove(activeClass);
    }

    const activePost = post || document.querySelector('.post__wrapper');
    if (activePost) {
      activePost.querySelector('.social').classList.add(activeClass);
    }
  }

  setScrollEvents() {
    const { scrollY, innerHeight } = this.window;

    this.setInviewPostUrl(scrollY, innerHeight);
  }

  setInviewPostUrl(windowPosition, screenHeight) {
    if (!this.posts || !this.posts.length) {
      return false;
    }
    const triggerPoint = windowPosition + screenHeight / 2;
    for (let i = 1; i <= this.posts.length; i += 1) {
      const post = this.posts[i - 1];
      const sectionTopPosition = post.offsetTop;
      const sectionBottomPosition = sectionTopPosition + post.clientHeight;
      const postId = parseFloat(post.dataset.id);

      if (
        this.activePost !== postId &&
        sectionTopPosition <= triggerPoint &&
        sectionBottomPosition > triggerPoint
      ) {
        this.activePost = postId;
        const postData = i === 1
          ? this.props.post
          : this.props.postFinite[i - 2];

        // React router redux does not support replace state without page refresh.
        this.props.dispatchInfiniteScrollUrlChange();
        window.history.replaceState({}, '', `/${postData.id}/${postData.slug}`);

        // Only track this again on first post onwards
        if (i > 1 && this.trackedPosts.indexOf(this.activePost) === -1) {
          this.trackedPosts.push(this.activePost);
          this.refreshThirdPartyTrackers(postData, i);
        }

        this.setActiveSocial(post);
      }
    }
    return false;
  }

  refreshThirdPartyTrackers(postData, pageNumber) {
    const { config } = this.props;
    const currentActivePostState = {
      context: {
        site: get(config, 'site'),
        type: 'post',
        postData
      },
      config
    };
    loadAllThirdPartyJs(currentActivePostState, pageNumber);
  }

  generateAdData(postData) {
    const { config } = this.props;
    const site = get(config, 'site') || 'fastcompany';
    const adData = buildPostAdModel(adsConfig, site, postData, 'postPage');

    return extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') || {} },
      { definitions: get(adData, 'config.definitions') || {} },
      { model: adData.model || {} }
    );
  }

  render() {
    const {
      config,
      statusCode,
      post,
      related,
      postpage,
      postVideo,
      postFinite
    } = this.props;

    if (postpage.error) {
      return (
        <section className="post-page">
          <article className="post__main--error-pg">
            <NotFound
              statusCode={statusCode}
              message={statusCode === 403 ? 'Post is not available.' : false}
            />
          </article>
        </section>
      );
    }

    if (postpage.isLoading) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const sticky = this.stickySidebar;

    return (
      <section className="post-page">
        <Post
          {...this.props}
          postExtras={true}
          isDesktop={sticky}
          combinedAdModel={this.generateAdData(post)}
          pageNum={0}
          relatedHeight={this.relatedHeight}
        />

        {postFinite.map((postData, index) =>
          <Post
            key={get(postData, 'id')}
            post={postData}
            related={related}
            postpage={postpage}
            postVideo={postVideo}
            postFinite={postFinite}
            isDesktop={sticky}
            pageNum={index + 1}
            combinedAdModel={this.generateAdData(postData)}
            modifier="divider"
            config={{ site: get(config, 'site') }}
            relatedHeight={this.relatedHeight}
            statusCode={statusCode}
          />
        )}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    statusCode: get(state, 'status.code'),
    config: state.config,
    postpage: state.postpage,
    post: get(state, 'post.data.post') || {},
    related: get(state, 'post.data.related') || [],
    postVideo: get(state, 'postVideo.data') || {
      feedid: '',
      playlist: [],
      title: ''
    },
    postAfterbodyRecircModuleType: get(
      state,
      'postAfterbodyRecircModuleType.data'
    ),
    postMoreStories: get(state, 'postMoreStories.data'),
    postFinite: get(state, 'postFinite.data.posts') || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchInfiniteScrollUrlChange() {
      dispatch(infiniteScrollUrlChange());
    },

    dispatchPostFinite(id, config) {
      return asyncPostFiniteActions(dispatch, id, config);
    }
  };
}

PostPage.propTypes = {
  statusCode: PropTypes.number.isRequired,
  config: PropTypes.shape({}).isRequired,
  dispatchInfiniteScrollUrlChange: PropTypes.func.isRequired,
  dispatchPostFinite: PropTypes.func.isRequired,
  post: PropTypes.shape({}).isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postpage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    postScrollDepth: PropTypes.number
  }).isRequired,
  postVideo: PropTypes.shape({
    feedid: PropTypes.string,
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    title: PropTypes.string
  }).isRequired,
  postFinite: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(PostPage);



// WEBPACK FOOTER //
// ./src/views/containers/pages/post_page/post_page.js